import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { accountsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import { useSaveUserGroup } from './_requests/saveUserGroup'
import Select from '../../../packages/kiti/components/form/Select'
import SelectWithInterpolation from '../../../packages/kiti-editor/components/select/SelectWithInterpolation'

const QUERY = gql`
  query Groups($search: String, $page: Int) {
    userGroups(search: $search, page: $page, sort: { field: NAME, type: ASC }) {
      id
      name
    }
  }
`

const useGroupsLoader = () => {
  const query = usePromiseQuery(QUERY, { client: accountsClient })

  return (search, page = 1) => {
    return query({ search, page })?.then(pathOr([], ['data', 'userGroups']))
  }
}

const GroupSelect = ({ onChange, value, interpolations = [], assign, multiple = false, ...props }) => {
  const createUserGroup = useSessionPermission('createUserGroup')
  const getOptions = useGroupsLoader()
  const [create] = useSaveUserGroup(result => onChange([...value, result]))

  const Component = !!interpolations.length ? SelectWithInterpolation : Select

  return (
    <Component
      value={value} //
      onChange={onChange}
      options={getOptions}
      onCreate={createUserGroup && create}
      interpolations={interpolations}
      multiple={multiple}
      assign={assign}
      {...props}
    />
  )
}

export default GroupSelect
